/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { GradeFrequenceExamInfoViewModel } from "../types/GradeFrequenceExamInfoViewModel.ts";

export const gradeFrequenceExamInfoViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  name: z.string().nullish(),
  weight: z.optional(z.number()),
}) as unknown as ToZod<GradeFrequenceExamInfoViewModel>;
